import React, { useState } from "react";
import { Link } from "react-router-dom";
import { HiOutlineArrowRight } from "react-icons/hi2";
import siteConfig from "../config/siteConfig";
import "../css/footer.scss";

function Footer() {
  const [email, setEmail] = useState("");
  const [isSubscribed, setIsSubscribed] = useState(false);

  const scrollToTop = () => {
    if (
      typeof window !== "undefined" &&
      typeof window.scrollTo === "function"
    ) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const handleNewsletterSubmit = (event) => {
    event.preventDefault();
    if (!email.trim()) return;
    setIsSubscribed(true);
    setEmail("");
  };

  return (
    <footer className="site-footer" role="contentinfo">
      <section
        className="footer-newsletter"
        id="newsletter"
        aria-labelledby="newsletter-title"
      >
        <div className="footer-newsletter__copy">
          <span className="footer-eyebrow">
            {siteConfig.newsletter.eyebrow}
          </span>
          <h2 id="newsletter-title">{siteConfig.newsletter.title}</h2>
          <p>{siteConfig.newsletter.description}</p>
        </div>

        <form
          className="footer-newsletter__form"
          onSubmit={handleNewsletterSubmit}
        >
          <label htmlFor="footer-newsletter-email">Email address</label>
          <div className="footer-newsletter__field">
            <input
              id="footer-newsletter-email"
              type="email"
              value={email}
              onChange={(event) => {
                setEmail(event.target.value);
                setIsSubscribed(false);
              }}
              placeholder="your@email.com"
              autoComplete="email"
              required
            />
            <button type="submit" aria-label="Subscribe to newsletter">
              <span>Sign up</span>
              <HiOutlineArrowRight aria-hidden="true" />
            </button>
          </div>
          <label className="footer-newsletter__consent">
            <input type="checkbox" required />
            <span>{siteConfig.newsletter.consent}</span>
          </label>
          <p
            className="footer-newsletter__status"
            role="status"
            aria-live="polite"
          >
            {isSubscribed
              ? "Thank you — please check your inbox to confirm."
              : ""}
          </p>
        </form>
      </section>

      <section className="footer-service" aria-label="Customer care">
        <div className="footer-service__intro">
          <span className="footer-eyebrow">WE'RE HERE TO HELP</span>
          <h2>Questions about your order?</h2>
        </div>
        <div className="footer-service__contact">
          <a href={`mailto:${siteConfig.contact.email}`}>
            {siteConfig.contact.email}
          </a>

          <span>{siteConfig.contact.hours}</span>
        </div>
        <Link
          className="footer-service__button"
          to="/contact"
          onClick={scrollToTop}
        >
          Contact us
          <HiOutlineArrowRight aria-hidden="true" />
        </Link>
      </section>

      <div className="footer-main">
        <div className="footer-main__brand">
          <Link
            className="footer-wordmark"
            to="/"
            onClick={scrollToTop}
            aria-label={siteConfig.logo.ariaLabel}
          >
            {siteConfig.logo.wordmark}
          </Link>
          <p>{siteConfig.description}</p>
          <span>{siteConfig.currency.label}</span>
        </div>

        <nav className="footer-main__navigation" aria-label="Footer navigation">
          {siteConfig.footerNavigation.map((group) => (
            <section className="footer-link-group" key={group.title}>
              <h2>{group.title}</h2>
              <ul>
                {group.links.map((link) => (
                  <li key={`${group.title}-${link.label}`}>
                    <Link to={link.href} onClick={scrollToTop}>
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </section>
          ))}
        </nav>
      </div>

      <div className="footer-bottom">
        <span>
          © {new Date().getFullYear()} {siteConfig.brandName}
        </span>
        <nav aria-label="Legal navigation">
          {siteConfig.legalNavigation.map((link) => (
            <Link key={link.label} to={link.href} onClick={scrollToTop}>
              {link.label}
            </Link>
          ))}
        </nav>
        <span className="footer-bottom__payments">
          Secure checkout · Visa · Mastercard · PayPal
        </span>
      </div>
    </footer>
  );
}

export default Footer;
